import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  /** JWT from URL or prior session; persisted via redux-persist. */
  token: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken(state, action) {
      const v = action.payload;
      state.token = v != null && typeof v === 'string' ? v.trim() : '';
    },
    clearAuthToken(state) {
      state.token = '';
    },
  },
});

export const { setAuthToken, clearAuthToken } = authSlice.actions;

export function selectAuthToken(state) {
  return state.auth?.token ?? '';
}

export default authSlice.reducer;
